/** shared between GroupChat and useUnreadCount — one RTK cache entry */
export const GROUP_HISTORY_LIMIT = 100;
export const GROUP_HISTORY_POLL_MS = 15_000;

/** quick-pick palette shown in the reaction picker. Users may pick any of these; the agent
 * (and the backend) accept any short emoji string. */
export const REACTION_PALETTE = ["👍", "❤️", "😂", "🔥", "😮", "😢", "🎉", "👏"] as const;
